import Vue from 'vue'

let MessageBox = Vue.extend({
  'template': ' <transition name="message">' +
  '   <div v-if="showMes" class="message-show">{{msg}}</div>' +
  '</transition>',
  data: function () {
    return {
      showMes: false
    }
  },
  mounted () {
    let that = this
    that.showMes = true
    setTimeout(function () {
      that.showMes = false
    }, 1000)
  }
})

let message = function (options) {
  let instance
  if (typeof options === 'string') {
    options = {
      message: options
    }
  }
  // 生成组件
  instance = new MessageBox({
    data: options
  })
  // 组件需要挂载在dom元素上
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  return instance.vm
}

export default message



// WEBPACK FOOTER //
// ./src/common/message.js